import { SensorType } from '@/interfaces/enums'
import type { ISensor } from '@/interfaces/entities/sensor'

const CORRELATION_TYPES: Record<SensorType, SensorType[]> = {
  [SensorType.ELECTRICITY]: [SensorType.ELECTRICITY, SensorType.TEMPERATURE, SensorType.DOOR_OPEN],
  [SensorType.TEMPERATURE]: [SensorType.TEMPERATURE, SensorType.ELECTRICITY, SensorType.DOOR_OPEN],
  [SensorType.DOOR_OPEN]: [SensorType.DOOR_OPEN, SensorType.ELECTRICITY, SensorType.TEMPERATURE],
  [SensorType.ROTATION]: [],
}

/** Tipos de sensor válidos para correlação com o sensor primário. */
export function getCorrelationSensorTypes(primaryType: SensorType | string | undefined): SensorType[] {
  if (!primaryType) return []
  return CORRELATION_TYPES[primaryType as SensorType] ?? []
}

/** Filtra sensores elegíveis para o dropdown secundário da série temporal. */
export function filterCorrelationSensors(
  sensors: ISensor[],
  primarySensor: ISensor | null | undefined,
  excludedSensorIds: number[] = [],
): ISensor[] {
  if (!primarySensor) return []

  const allowedTypes = getCorrelationSensorTypes(primarySensor.sensor_type)
  if (allowedTypes.length === 0) return []

  const excluded = new Set(excludedSensorIds.map((id) => String(id)))
  excluded.add(String(primarySensor.id))

  return sensors.filter(
    (sensor) =>
      !excluded.has(String(sensor.id)) &&
      allowedTypes.includes(sensor.sensor_type as SensorType),
  )
}

export function isCorrelationSensorCompatible(
  primarySensor: ISensor | null | undefined,
  secondarySensor: ISensor | null | undefined,
): boolean {
  if (!primarySensor || !secondarySensor) return false
  if (String(primarySensor.id) === String(secondarySensor.id)) return false
  return getCorrelationSensorTypes(primarySensor.sensor_type).includes(
    secondarySensor.sensor_type as SensorType,
  )
}
